// extracted by mini-css-extract-plugin
export var numberInputContainer = "_7m-0";
export var startPickingButton = "_7m-1";